import { Component, viewChild } from '@angular/core';
import { UIIconComponent } from '@design-system';
import { BottomSheetComponent } from '../../../../components/bottom-sheet/bottom-sheet.component';
import { SOCIAL_LINKS } from '../../menu.model';

/**
 * The شبکه‌های اجتماعی sheet — the published EasyTrader channels.
 *
 * The channels are plain anchors rather than click handlers: they are external
 * destinations, so the browser (and the OS, when the app is installed) gets to
 * open them the way it opens any other outbound link — long-press, copy, open
 * in the Telegram or Instagram app — instead of a `window.open` a popup blocker
 * may swallow. `rel` is set because they open in a new context.
 */
@Component({
	selector: 'app-social-links-bottom-sheet',
	imports: [BottomSheetComponent, UIIconComponent],
	templateUrl: './social-links-bottom-sheet.component.html',
	host: {
		'data-cy': 'social-links-bottom-sheet'
	}
})
export class SocialLinksBottomSheetComponent {
	private readonly sheet = viewChild<BottomSheetComponent>('sheet');

	readonly links = SOCIAL_LINKS;

	open(): Promise<void> {
		return this.sheet()?.open() ?? Promise.resolve();
	}

	close(): Promise<void> {
		return this.sheet()?.close() ?? Promise.resolve();
	}
}
